import { request } from '../dataApi/_request/index'
import Api from '../apis/api'

// 获取部门列表
export function getBranch(params) {
  return request({
    method: 'post',
    url: Api.getBranch,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    },
    data: {
      ...params
      // destination_id: store.state.userInfo.destination_id,
    }
  })
}
// 新增部门
export function addBranch(params) {
  return request({
    method: 'post',
    url: Api.addBranch,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    },
    data: {
      ...params
      // destination_id: store.state.userInfo.destination_id,
    }
  })
}
// 修改部门
export function modifyBranch(params) {
  return request({
    method: 'post',
    url: Api.modifyBranch,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    },
    data: {
      ...params
      // destination_id: store.state.userInfo.destination_id,
    }
  })
}
// 删除部门
export function deleteBranch(params) {
  return request({
    method: 'post',
    url: Api.deleteBranch,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    },
    data: {
      ...params
      // destination_id: store.state.userInfo.destination_id,
    }
  })
}
